module.exports = __webpack_public_path__ + "static/media/pe.736a15f5.jpg";